(function ($) {
  'use strict';

  function cwParseAjaxResponse(raw) {
    if (raw == null || raw === '') {
      return null;
    }
    if (typeof raw === 'object') {
      return raw;
    }
    if (typeof raw === 'string') {
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function cwApplyCartFragments(fragments) {
    if (window.CustomWearCart && typeof window.CustomWearCart.applyFragments === 'function') {
      window.CustomWearCart.applyFragments(fragments);
      return;
    }
    if (!fragments || typeof fragments !== 'object') {
      return;
    }
    $.each(fragments, function (key, value) {
      var $targets = $(key);
      if ($targets.length) {
        $targets.replaceWith(value);
      }
    });
  }

  function disableWooVariationAjax($form) {
    $form.off('should_send_ajax_request.adding_to_cart.cwAtc');
    $form.on('should_send_ajax_request.adding_to_cart.cwAtc', function () {
      return false;
    });
  }

  function serializeAddToCartForm(form, submitter) {
    var fd;
    try {
      fd = submitter ? new FormData(form, submitter) : new FormData(form);
    } catch (errFd) {
      fd = new FormData(form);
    }

    var variationIdEl = form.querySelector('input[name="variation_id"]');
    var variationId = variationIdEl ? parseInt(String(variationIdEl.value || '0'), 10) : 0;
    var payload = {};
    var qty = 1;

    fd.forEach(function (value, key) {
      if (value instanceof File) {
        return;
      }
      if (key === 'add-to-cart') {
        return;
      }
      if (key === 'quantity') {
        qty = parseInt(String(value), 10);
        if (!isFinite(qty) || qty < 1) {
          qty = 1;
        }
        return;
      }
      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        return;
      }
      payload[key] = String(value);
    });

    payload.quantity = String(qty);

    if (variationId > 0) {
      payload.product_id = String(variationId);
      payload.variation_id = String(variationId);
    } else if (!payload.product_id) {
      var pidEl = form.querySelector('input[name="product_id"]');
      var pid =
        (pidEl && pidEl.value) ||
        (function () {
          var b = form.querySelector('button[name="add-to-cart"], input[name="add-to-cart"]');
          return b ? b.value : '';
        })();
      if (pid) {
        payload.product_id = String(pid);
      }
    }

    return $.param(payload);
  }

  $(function () {
    $('form.variations_form').each(function () {
      disableWooVariationAjax($(this));
    });
  });

  $(document.body).on('wc_variation_form', 'form.variations_form', function () {
    disableWooVariationAjax($(this));
  });

  $(document).on('submit', 'form.cart', function (e) {
    var $form = $(this);

    if ($form.hasClass('variations_form')) {
      var variationId = parseInt(String($form.find('input[name="variation_id"]').val() || '0'), 10);
      if (variationId <= 0) {
        return;
      }
    }

    if (typeof wc_add_to_cart_params === 'undefined') {
      return;
    }

    if ($form.data('cwAtcBusy')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var form = $form[0];
    var $btn = $form.find('[type="submit"]');
    var ev = e.originalEvent;
    var submitter = ev && ev.submitter ? ev.submitter : null;
    var data = serializeAddToCartForm(form, submitter);

    $form.data('cwAtcBusy', true);
    $btn.prop('disabled', true).addClass('cw-atc-loading');

    $.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'),
      data: data,
      dataType: 'json',
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      success: function (raw) {
        var response = cwParseAjaxResponse(raw);
        if (!response || response.error) {
          if (response && response.product_url) {
            window.location = response.product_url;
          }
          return;
        }

        var fr = response.fragments;
        if (window.CustomWearCart && typeof window.CustomWearCart.applyFragments === 'function') {
          $(document.body).trigger('added_to_cart', [fr, response.cart_hash, $btn]);
        } else {
          cwApplyCartFragments(fr);
          $(document.body).trigger('added_to_cart', [fr, response.cart_hash, $btn]);
        }
      },
      error: function () {},
      complete: function () {
        $form.data('cwAtcBusy', false);
        $btn.prop('disabled', false).removeClass('cw-atc-loading');
      },
    });
  });
})(jQuery);
